
import React from 'react';
import Cookies from 'universal-cookie';
import getClient from '../services/getClient';

export default class AdWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    pushAd() {
        try {   
            const adsbygoogle = window.adsbygoogle;
            adsbygoogle.push({});
        } catch(e) {
            console.error(e);
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    async componentDidMount() {

        let cliente = await getClient('', '', new Cookies().get('db', { path: '/' }));
        if (cliente.ads_active && cliente.type === '0') {
            this.interval = setInterval(() => {
                if(window.adsbygoogle) {
                    this.pushAd();
                    clearInterval(this.interval);
                }
            }, 500); 
        }
    }

    render() {

        return(
            <div style={{ position: 'fixed', textAlign: 'center', bottom: 0, left: 100, height: '100px', width: '100%' }}>
                
                {/* Ads by Google */}
                { this.props.bottomWidget &&
                    <ins className="adsbygoogle" style={{ display: 'inline-block', width: '728px', height:'100px' }} data-ad-client="ca-pub-9797244259896003" data-ad-slot="1841654923"></ins>
                }
            </div>
        );
    }
}